import { IUser } from "@/api";
import { UserScopeCount } from "@/components/admin/table/cells/UserScopeCount";
import { Stack, Typography } from "@mui/material";

interface IProps {
    user: IUser;
}

export const UserActivity = ({ user }: IProps) => {
    return (
        <Stack gap={2}>
            <Typography variant="h6">Activity</Typography>
            <Stack gap={2}>
                {/* ID */}
                <Stack>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        fontWeight={500}
                        gutterBottom
                    >
                        Scopes run
                    </Typography>
                    <Typography variant="h5" fontWeight={600}>
                        <UserScopeCount userId={user.id} />
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
